import { useEffect } from "react";

import { useDispatch } from "react-redux";

import { onlineManager } from "@tanstack/react-query";
import FullStory from "services/Fullstory";

import ErrorLoggerService from "core/ErrorLoggerService";

import { confirmActions, type ConfirmState } from "../../containers/Confirm/Confirm.slice";
import { useConfirm } from "../../containers/Confirm/Confirm.context";

const OFFLINE_DIALOG: ConfirmState = {
  id: "offline-status-dialog",
  subType: "error",
  icon: "warning",
  title: "Sin conexión",
  content: "Parece que no tienes conexión a Internet.",
  description:
    "Algunas funciones pueden no estar disponibles. La conexión se restablecerá automáticamente.",
  showButtonNo: false,
  buttonYes: "Entendido"
};

function NetworkStatus() {

  const dispatch = useDispatch();
  const confirm = useConfirm();

  useEffect(() => {
    const handleOnlineStatusChanged = async(isOnline: boolean) => {
      try {
        if (isOnline) {
          FullStory.sendEvent("User Back Online", {});
          dispatch(confirmActions.hide());
          return;
        }

        FullStory.sendEvent("User Went Offline", {});
        await confirm(OFFLINE_DIALOG);
      }
      catch (err) {
        ErrorLoggerService("APP", "NetworkStatus", err);
      }
    };

    if (!onlineManager.isOnline()) {
      handleOnlineStatusChanged(false);
    }

    return onlineManager.subscribe(handleOnlineStatusChanged);
  }, [ dispatch, confirm ]);

  return null;
}

export default NetworkStatus;
